import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SimpleToast from '../SimpleToast.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StopOrderTriggeredToast',
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleToast, {
    "icon-name": "info-circle-bulk",
    title: "modules.myOrders.toasts.stopOrder.title",
    message: "modules.myOrders.toasts.stopOrder.message",
    onRemove: _cache[0] || (_cache[0] = ($event: any) => (emit('remove')))
  }))
}
}

})